<input
  payee-input
  [matDatepicker]="picker"
  [placeholder]="placeholder"
  [min]="min"
  [max]="max"
  [value]="value"
  [disabled]="disabled"
  (click)="open()"
  (dateChange)="onDateChange($event)"
/>
<button
  payee-suffix
  payee-icon-button
  type="button"
  color="custom"
  [disabled]="disabled"
  (click)="open()"
>
  @if (!disabled) {
    <payee-icon
      name="calendar"
      width="24"
      height="24"
    ></payee-icon>
  }
  @if (disabled) {
    <payee-icon
      name="disabled-calendar"
      width="24"
      height="24"
    ></payee-icon>
  }
</button>
<mat-datepicker #picker></mat-datepicker>
